'use strict';

module.exports = {
    PROMOTION_SPLITTING: 'promotion_splitting',
};
